export class Auth {
    public UserName: string;
    public Password: string;
    public LoginByAdmin: boolean;
}



// WEBPACK FOOTER //
// ./src/models/auth.model.ts